
import { supabase } from "@/integrations/supabase/client";
import { LeadAccount } from "@/types/strategy-types";

export const fetchLeadAccounts = async (isAdmin: boolean, providerId: string | null) => {
  let query = supabase
    .from('lead_account')
    .select(`
      *,
      strategy_provider:strategy_provider_id(name)
    `);

  // Only filter by provider if not admin and provider ID is present
  if (!isAdmin && providerId) {
    query = query.eq('strategy_provider_id', providerId);
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching lead accounts:', error);
    throw error;
  }

  return data.map(account => ({
    ...account,
    provider_name: account.strategy_provider?.name
  }));
};

export const createLeadAccountApi = async (leadAccount: Omit<LeadAccount, 'id' | 'created_at' | 'updated_at'>) => {
  const { error } = await supabase
    .from('lead_account')
    .insert(leadAccount)
    .select();

  if (error) throw error;
};

export const updateLeadAccountApi = async (id: string, leadAccount: Partial<LeadAccount>) => {
  const { error } = await supabase
    .from('lead_account')
    .update(leadAccount)
    .eq('id', id);

  if (error) throw error;
};

export const deleteLeadAccountApi = async (id: string) => {
  const { error } = await supabase
    .from('lead_account')
    .delete()
    .eq('id', id);

  if (error) throw error;
};

export const getUserProviderRole = async (userId: string) => {
  const { data, error } = await supabase
    .from('user_roles')
    .select('provider_id, role')
    .eq('user_id', userId)
    .single();

  if (error) {
    console.error('Error getting user role:', error);
    return null;
  }

  return data;
};

export const checkIsAdmin = async (userId: string) => {
  const { data, error } = await supabase
    .rpc('check_is_admin', { user_id: userId });

  if (error) {
    console.error('Error checking admin status:', error);
    return false;
  }

  return data;
};
